import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth.service';

@Component({
  template: '',
  selector: 'app-login'
})
export class LogoutComponent implements OnInit {

  constructor(private _auth: AuthService) { }

  ngOnInit() {
    // this._auth.processLogout().then(user => {
    //   window.location.href = 'http://localhost:3000';
    // });
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/core/auth/logout.component.ts